import Keycloak from 'keycloak-js';
import kavach_api_url from '../constants';
let config = require('../../config');
let keycloakUrl = process.env.NODE_ENV === 'production' ? config.build.keycloakUrl : config.dev.keycloakUrl;
const enableKavach = process.env.NODE_ENV === 'production' ? config.build.enableKavach : config.dev.enableKavach;
let kavachClientId = process.env.NODE_ENV === 'production' ? config.build.kavachClientId : config.dev.kavachClientId;
const keycloak = new Keycloak({
    url: keycloakUrl,
    realm: 'xpressbees',
    clientId: kavachClientId,
    onLoad: 'login-required'
});
keycloak.enableKavach = enableKavach;

async function getAuthToken() {
    // Check if the token is expired.
    if (keycloak.tokenExpired) {
        // Refresh the token.
        await keycloak.updateToken();
    }
    // Return the token.
    return keycloak.token;
}

/**
 * This function will redirect the user on confirm logout screen
 */

 keycloak.logoutWithoutTokenId = () => {
    localStorage.removeItem('lmaccesspermissiondata')
    localStorage.removeItem('lmaccessuserdata')
    localStorage.removeItem('userToken')
    localStorage.removeItem('isLoggedIn')
    localStorage.removeItem('IsRVPPaperless')
    localStorage.removeItem('isLoginAuthCheck')
    localStorage.removeItem('refreshToken')
    localStorage.removeItem('IsLocusRouting')
    localStorage.removeItem('isDayendclosurefeature')
    localStorage.removeItem('hubaccesslist')
    localStorage.removeItem('lmUserToken')
    localStorage.removeItem('lmUserTokenId')
    localStorage.removeItem('userUniqueKey')
    localStorage.removeItem('printRoute')
    localStorage.removeItem('onepagerprintflag')
    window.location.href = keycloakUrl+"realms/xpressbees/protocol/openid-connect/logout?client_id="+kavachClientId+"&post_logout_redirect_uri="+kavach_api_url.kavach_logout_url;
}

keycloak.logoutWithTokenId = () => {
    let tokenId = window.localStorage.getItem('lmUserTokenId');
    localStorage.removeItem('lmaccesspermissiondata')
    localStorage.removeItem('lmaccessuserdata')
    localStorage.removeItem('isLoggedIn')
    localStorage.removeItem('IsRVPPaperless')
    localStorage.removeItem('isLoginAuthCheck')
    localStorage.removeItem('refreshToken')
    localStorage.removeItem('IsLocusRouting')
    localStorage.removeItem('isDayendclosurefeature')
    localStorage.removeItem('lmUserToken')
    localStorage.removeItem('lmUserTokenId')
    localStorage.removeItem('userUniqueKey')
    localStorage.removeItem('hubaccesslist')
    localStorage.removeItem('printRoute')
    localStorage.removeItem('missinghubids')
    localStorage.removeItem('onepagerprintflag')
    //window.location.href = keycloakUrl+"/realms/xpressbees/protocol/openid-connect/logout?id_token_hint=" + tokenId + "&post_logout_redirect_uri=https%3A%2F%2Flastmileallocationpod-appstage.xbees.in%2F";
    window.location.href = keycloakUrl+"realms/xpressbees/protocol/openid-connect/logout?client_id="+kavachClientId+"&post_logout_redirect_uri="+kavach_api_url.kavach_logout_url;
}



export default keycloak;


// WEBPACK FOOTER //
// ./src/common/Keycloak.js